import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getServicioAll, getServicioAllxArea, setBloqueaServicio } from "../../services/servicios";
import IconM from "../dashboard/menu/icons/Icon";
import ServiceModal from "./servicemodal";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";

function ServiceView() {
  const [area, setArea] = useState([]);
  const [servicio, setServicio] = useState([]);
  const [page, setPage] = useState(1);
  const { setShowToast, setOpciones } = ErrorContext();
  const [AreaId, setAreaId] = useState(0);
  const [AreaFId, setAreaFId] = useState(0);
  const [ServicioId, setServicioId] = useState(0);
  const [showM, setShowM] = useState(false);
  const [tag, setTag] = useState(0);
  const [estado, setEstado] = useState("AC");
  const [selectedRow, setSelectedRow] = useState(null);
  const { slice, range } = useTable(servicio, page, 10);
  
  //------- Metodo para mostrar las areas en la grilla
  const fillService = async () => 
    {
       setShowToast(false);
       const response = await getServicioAll();
       if (response) 
        {
          if (response.status === 200) 
            {
              setServicio(response.data.data);
              setArea(response.data.area);
            } 
          else 
           {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
           }
        }
     };

  //----- boton crear-Editar-Eliminar Area
  const handleCrearService = (tagId) => 
    {
      if (tagId === 0) 
        {
         setAreaId(AreaFId);
         setServicioId(0);
        }
      if (tagId ===2)
        setSelectedRow(null);

      setShowM(true);
      setTag(tagId);
  };

  //------ Bloquea- Desbloquea
  const handleBloqueaService = async (tagId) => 
    {
      setShowToast(false);
      const response = await setBloqueaServicio(AreaId, ServicioId, tagId);
      if (response) 
        {
          if (response.status === 200) 
            {
              setTag(0);
              setEstado(response.data.data[0].Estado);
              setAreaId(response.data.data[0].AreaId);
              handleFiltrar(AreaFId);
            } 
          else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
            }
        }
    };
   
  //-----------------------------
  const handlefilas = (Item, index) => 
  {
    setSelectedRow(index);  
    setAreaId(Item.AreaId);
    setServicioId(Item.ServicioId);
    setEstado(Item.Estado);
    
  };

  //------------ Filtrar por area
  const handleFiltrar =async(area) =>
    {
      let response=[];
      setAreaFId(area);
      if (area ===0) 
       { 
         response = await getServicioAll();
       }  
      else 
       {   
         response = await getServicioAllxArea(area);
       }  
      if (response) 
        {
          if (response.status === 200) 
            {
              setServicio(response.data.data);
            } 
          else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
       }   
    }
  
  /**
   *Llamada al iniciar
   */
  useEffect(() => 
    {
      setShowM(false);
      fillService();
    }, []);
  return (
    <>
      <div className="">
         <div className="paneltitle">
            <label className="text-[1.0rem] font-light text-gray-400 leading-none">Administración/Digiturno/Servicios</label>
         </div>
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleCrearService(0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Nuevo</span>
            </button>
            
            <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearService(1)}>
              <IconM svg="pencil" className="iconmenu" title="pencil" />
              <span>Editar</span>
            </button>
       
            <button className="btnmenu" id="Eliminar" onClick={() => handleCrearService(2)} disabled={selectedRow === null}>
              <IconM svg="delfile" className="iconmenu" title="delfile" />
              <span>Eliminar</span>
            </button>

            {estado === "AC" ? 
            (
               <button className="btnmenu" id="Bloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaService(0)}>
                   <IconM svg="lock" className="iconmenu" title="lock" />
                   <span>Bloquear</span>
                </button>
            ) : 
            (
              <button className="btnmenu" id="Desbloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaService(1)}>
                 <IconM svg="dlock" className="iconmenu" title="dlock"/>
                 <span>Desbloquear</span>
              </button>
            )}
        </div>
        <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
         <table className="w-full table-auto">
            <thead className="border-b border-stone-200 text-sm font-medium ">
               <tr>
                   <th className="px-2.5 py-2 text-start font-medium">Id.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                   <th className="px-2.5 py-2 text-start font-medium">Area</th>
                   <th className="px-2.5 py-2 text-start font-medium">
                      Prefijo
                    </th>
                   <th className="px-2.5 py-2 text-start font-medium">Digitos Prefijo</th>
                   <th className="px-2.5 py-2 text-start font-medium">Orden</th>
                   <th className="px-2.5 py-2 text-start font-medium">Estado</th>
               </tr>
            </thead>
            <tbody className="group text-sm text-stone-800 ">
               {slice.map((item, index) => {
                  return (
                    <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.ConsultID}`} onClick={() => handlefilas(item, index)}>
                       <td className="">{item.ServicioId}</td>
                       <td>{item.NombreServ}</td>
                       <td>{item.NombreArea}</td>
                       <td className="item-center">{item.Prefijo}</td>
                       <td className="item-center">{item.Maximo}</td>
                       <td className="item-center">{item.Orden}</td>
                       <td className="item-center">
                          {item.Estado === "AC" ? (<span className="tagac">Activo</span>) : (<span className="tagan">Suspendido</span>)}
                       </td>
                    </tr>
                  )})}
            </tbody>
         </table>

        </div>
       <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
     </div>

<ServiceModal
        show={showM}
        AreaI={AreaId}
        AreaFId ={AreaFId}
        ServicioI={ServicioId}
        Tag={tag}
        handleshow={setShowM}
        handleFiltrar={handleFiltrar}
      ></ServiceModal>
    </>
  );
}
export default ServiceView;
